import React from 'react';
import { useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import clsx from 'clsx';
import classes from './Notification.module.scss';

const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const show = (variantType = 'default', key, message, { actions, ...options } = {}) => {
    enqueueSnackbar(message, {
      key,
      variant: variantType,
      autoHideDuration: 3000,
      className: clsx(classes.snackbar, classes[`snackbar--${variantType}`]),
      action: (
        <>
          {actions}
          <IconButton
            onClick={() => {
              closeSnackbar(key);
            }}>
            <CloseIcon />
          </IconButton>
        </>
      ),
      ...options,
    });
  };
  return [show, closeSnackbar];
};

export default useNotification;
